import ApiService from './api.service';

const GuestbookService = token => {
    const api = ApiService.createApiInstance(token);

    const controllerBase = '/guest-book';

    return {
        getResponsesByService(serviceId, params) {
            return api.get(controllerBase + `/service/${serviceId}`, { params });
        },
        getResponsesByFuneralHome(funeralHomeId, params) {
            return api.get(controllerBase + `/funeral-home/${funeralHomeId}`, { params });
        },
        getResponsesAdmin(params) {
            const { status, ...rest } = params;

            let url = controllerBase + `/admin`;

            if (Array.isArray(status) && status.length > 0) {
                const statusQuery = status.map(s => `status=${encodeURIComponent(s)}`).join('&');
                url += `?${statusQuery}`;
            }

            return api.get(url, { params: rest });
        },
        getResponsesOwner(params) {
            const { status, ...rest } = params;

            let url = controllerBase + `/owner`;

            if (Array.isArray(status) && status.length > 0) {
                const statusQuery = status.map(s => `status=${encodeURIComponent(s)}`).join('&');
                url += `?${statusQuery}`;
            }

            return api.get(url, { params: rest });
        },
        getResponse(responseId) {
            return api.get(controllerBase + `/${responseId}`);
        },
        updateResponseStatus(responseId, status) {
            return api.post(controllerBase + `/update-moderated-status/${responseId}/${status}`);
        },
        updateResponseStatusMulti(responseIds, funeralHomeId, status) {
            return api.post(controllerBase + `/update-moderated-status-multi/${status}`, responseIds, {
                params: { funeralHomeId },
            });
        },
        deleteResponse(responseId) {
            return api.delete(controllerBase + `/${responseId}`);
        },
        getConfigPresets() {
            return api.get(controllerBase + `/config-presets`);
        },
        getNextUnknownByService(serviceId, orderByAsc = false, startAfterId = null) {
            return api.get(controllerBase + `/service/${serviceId}/next-unknown`, {
                params: {
                    orderByAsc,
                    startAfterId,
                },
            });
        },
        getNextUnknownByFuneralHome(funeralHomeId, orderByAsc = false, startAfterId = null) {
            return api.get(controllerBase + `/funeral-home/${funeralHomeId}/next-unknown`, {
                params: {
                    orderByAsc,
                    startAfterId,
                },
            });
        },
        getNextUnknownByOwner(ownerId, orderByAsc = false, startAfterId = null) {
            return api.get(controllerBase + `/owner/${ownerId}/next-unknown`, {
                params: {
                    orderByAsc,
                    startAfterId,
                },
            });
        },
        getServiceSubmissionCutoffDate(serviceId) {
            return api.get(controllerBase + `/submission-cutoff/service/${serviceId}`);
        },
        updateGuestbookResponseMessage(responseId, message) {
            return api.post(controllerBase + `/update-message/${responseId}`, {
                message,
            });
        },
        getOwners(params) {
            return api.get('/owners', { params })
        },

        // Add CSV export methods to the GuestbookService
        exportResponsesByFuneralHome(funeralHomeId, params) {
            // Create a copy of params without pageSize and pageNumber
            const { pageSize, pageNumber, ...exportParams } = params;

            return api.post(`${controllerBase}/funeral-home/${funeralHomeId}/export`, null, {
                params: exportParams,
                responseType: 'blob',
            });
        },

        async exportResponsesByService(serviceId, params) {
            // Create a copy of params without pageSize and pageNumber
            const { pageSize, pageNumber, ...exportParams } = params;

            // Add serviceId to params
            exportParams.serviceId = serviceId;

            return api.post(`${controllerBase}/service/${serviceId}/export`, null, {
                params: exportParams,
                responseType: 'blob',
            });
        },

        exportResponsesOwner(params) {
            // Extract status from params to handle it separately
            const { status, pageSize, pageNumber, ...rest } = params;

            let url = `/owner/export`;

            // Handle status array the same way as in getResponsesOwner
            if (Array.isArray(status) && status.length > 0) {
                const statusQuery = status.map(s => `status=${encodeURIComponent(s)}`).join('&');
                url += `?${statusQuery}`;
            }

            return api.post(`${ controllerBase }/${url}`, null, {
                params: rest,
                responseType: 'blob',
            });
        },

        exportResponsesAdmin (params) {
            // Extract status from params to handle it separately
            const { status, pageSize, pageNumber, ...rest } = params;

            let url = `/admin/export`;

            // Handle status array the same way as in getResponsesAdmin
            if (Array.isArray(status) && status.length > 0) {
                const statusQuery = status.map(s => `status=${encodeURIComponent(s)}`).join('&');
                url += `?${statusQuery}`;
            }

            return api.post(`${controllerBase}/${url}`, null, {
                params: rest,
                responseType: 'blob',
            });
        },
    };
};

export default GuestbookService;
